var _path, _path2, _path3, _path4, _path5, _circle, _path6;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDarkCertificateAuth(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 27,
    viewBox: "0 0 27 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21 24.5789H5.42104V6.0383M5.42104 6.0383V3.21052C5.42104 1.98737 4.43368 1 3.21052 1C1.98737 1 1 1.98737 1 3.21052V6.0383H5.42104Z",
    stroke: "#6B696A",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.21069 1H21.6317C22.8549 1 23.8422 1.98737 23.8422 3.21052V24.5789H20.8949",
    stroke: "#6B696A",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.10474 9.84143H20.1573",
    stroke: "#6B696A",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M9.10474 12.7897H15.7363",
    stroke: "#6B696A",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M9.10474 6.89465H20.1573",
    stroke: "#6B696A",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 21,
    cy: 21,
    r: 6,
    fill: "#368FEF"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M19.7751 23.7875C19.7084 23.7875 19.6459 23.777 19.5876 23.7562C19.5292 23.7354 19.4751 23.7 19.4251 23.65L17.2751 21.5C17.1834 21.4083 17.1397 21.2895 17.1438 21.1437C17.148 20.9979 17.1959 20.8791 17.2876 20.7875C17.3792 20.6958 17.4959 20.65 17.6376 20.65C17.7792 20.65 17.8959 20.6958 17.9876 20.7875L19.7751 22.575L24.0126 18.3375C24.1042 18.2458 24.223 18.2 24.3688 18.2C24.5147 18.2 24.6334 18.2458 24.7251 18.3375C24.8167 18.4291 24.8626 18.5479 24.8626 18.6937C24.8626 18.8395 24.8167 18.9583 24.7251 19.05L20.1251 23.65C20.0751 23.7 20.0209 23.7354 19.9626 23.7562C19.9042 23.777 19.8417 23.7875 19.7751 23.7875Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDarkCertificateAuth);
export default __webpack_public_path__ + "static/media/dark_certificate_auth.bf8cc7959247e30afc608e413ed0c4a2.svg";
export { ForwardRef as ReactComponent };